import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const seoMeta = (titleKey, descriptionKey, fullTitle = false) => ({
  seo: {
    titleKey,
    descriptionKey,
    fullTitle
  }
})

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: seoMeta('common.pageTitle', 'hero.description', true)
  },
  // About submenu routes
  {
    path: '/about/overview',
    name: 'AboutOverview',
    component: () => import('../views/about/Overview.vue'),
    meta: seoMeta('aboutOverview.title', 'aboutOverview.introText1')
  },
  {
    path: '/about/hangzhou',
    name: 'AboutHangzhou',
    component: () => import('../views/about/Hangzhou.vue'),
    meta: seoMeta('hangzhou.title', 'hangzhou.officeDesc1')
  },
  {
    path: '/about/shanghai',
    name: 'AboutShanghai',
    component: () => import('../views/about/Shanghai.vue'),
    meta: seoMeta('shanghai.title', 'shanghai.officeDesc1')
  },
  {
    path: '/about/wuhan',
    name: 'AboutWuhan',
    component: () => import('../views/about/Wuhan.vue'),
    meta: seoMeta('wuhan.title', 'wuhan.officeDesc1')
  },
  // Services submenu routes
  {
    path: '/services/expert',
    name: 'ServicesExpert',
    component: () => import('../views/services/Expert.vue'),
    meta: seoMeta('servicesExpert.title', 'servicesExpert.introText1')
  },
  {
    path: '/services/data',
    name: 'ServicesData',
    component: () => import('../views/services/Data.vue'),
    meta: seoMeta('servicesData.title', 'servicesData.introText1')
  },
  {
    path: '/services/roadshow',
    name: 'ServicesRoadshow',
    component: () => import('../views/services/Roadshow.vue'),
    meta: seoMeta('servicesRoadshow.title', 'servicesRoadshow.introText1')
  },
  {
    path: '/services/sitevisit',
    name: 'ServicesSiteVisit',
    component: () => import('../views/services/SiteVisit.vue'),
    meta: seoMeta('servicesSiteVisit.title', 'servicesSiteVisit.introText1')
  },
  {
    path: '/services/research',
    name: 'ServicesResearch',
    component: () => import('../views/services/Research.vue'),
    meta: seoMeta('servicesResearch.title', 'servicesResearch.introText1')
  },
  // Clients submenu routes
  {
    path: '/clients/enterprise',
    name: 'ClientsEnterprise',
    component: () => import('../views/clients/Enterprise.vue'),
    meta: seoMeta('clientsEnterprise.title', 'clientsEnterprise.introText1')
  },
  {
    path: '/clients/professional',
    name: 'ClientsProfessional',
    component: () => import('../views/clients/Professional.vue'),
    meta: seoMeta('clientsProfessional.title', 'clientsProfessional.introText1')
  },
  {
    path: '/clients/financial',
    name: 'ClientsFinancial',
    component: () => import('../views/clients/Financial.vue'),
    meta: seoMeta('clientsFinancial.title', 'clientsFinancial.introText1')
  },
  // Advantages submenu routes
  {
    path: '/advantages/overview',
    name: 'AdvantagesOverview',
    component: () => import('../views/advantages/Overview.vue'),
    meta: seoMeta('advantagesPage.title', 'advantagesPage.subtitle')
  },
  // Expert Agreement page
  {
    path: '/expert-agreement',
    name: 'ExpertAgreement',
    component: () => import('../views/ExpertAgreement.vue'),
    meta: seoMeta('seo.expertAgreementTitle', 'seo.expertAgreementDescription')
  },
  // Compliance Framework page
  {
    path: '/compliance-framework',
    name: 'ComplianceFramework',
    component: () => import('../views/ComplianceFramework.vue'),
    meta: seoMeta('complianceFramework.title', 'compliance.description')
  },
  // Expert Introduction page
  {
    path: '/expert-introduction',
    name: 'ExpertIntroduction',
    component: () => import('../views/ExpertIntroduction.vue'),
    meta: seoMeta('expertIntroduction.title', 'expertIntroduction.overview.description')
  },
  // 旧官网路径仅作为用户访问兜底；生产环境仍需在阿里云配置服务端 301。
  {
    path: '/sy',
    redirect: { name: 'Home' }
  },
  {
    path: '/gywm',
    redirect: { name: 'AboutOverview' }
  },
  {
    path: '/zyfw',
    redirect: { name: 'ServicesExpert' }
  },
  {
    path: '/hyhy',
    redirect: { name: 'ServicesRoadshow' }
  },
  {
    path: '/hyzx',
    redirect: { name: 'ServicesResearch' }
  },
  {
    path: '/hyfg',
    redirect: { name: 'ExpertIntroduction' }
  },
  {
    path: '/Compliance',
    redirect: { name: 'ComplianceFramework' }
  },
  {
    path: '/compliance',
    redirect: { name: 'ComplianceFramework' }
  },
  {
    path: '/hgtx',
    redirect: { name: 'ComplianceFramework' }
  },
  {
    path: '/lxwm',
    redirect: { name: 'Home', hash: '#contact' }
  },
  {
    path: '/gyhyzjwlxy',
    redirect: { name: 'ExpertAgreement' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    }

    return { top: 0 }
  }
})

export default router
